import React from "react";
import { Route } from "react-router-dom";
import {  notUndefinedAndNull } from "../utils/Validation";

/**
 * A public route component used for URLs which are accessiable publically only.
 *
 * If a logged in seession is found, user will be redirected to the dashboard of the application.
 */
const PublicRoute = ({ component: Component, title, ...rest }) => (
  <Route
    {...rest}
    render={props =>
       getComponent(props,title,Component)
    }
  />
);

export default PublicRoute;

function getComponent(props, title, Component){

  if(notUndefinedAndNull(title)){
    props.location.state = {
      ...props.location.state,
      pageTitle: title
    }
  }
  
  return <Component {...props} />
}

// PublicRoute.propTypes = {
//   path: PropTypes.string,
//   exact: PropTypes.bool,
//   component: PropTypes.element
// };
